

document.querySelector('#ouvre-candidats').addEventListener("click", function(e){
  e.preventDefault();
  desactiveMegamenus()
  ouvreMegamenu ('#menu-candidats')

});

document.querySelector('#ouvre-themes').addEventListener("click", function(e){
  e.preventDefault();
  desactiveMegamenus()
  ouvreMegamenu ('#menu-themes')

});

if (document.querySelector('#ouvre-synthese')) {
  document.querySelector('#ouvre-synthese').addEventListener("click", function(e){
    e.preventDefault();
    desactiveMegamenus()
    ouvreMegamenu ('#menu-synthese')
  
  });
}

let fermer =document.querySelectorAll('.megamenu .bt-fermer')
for (let i = 0; i < fermer.length; i++) {
  fermer[i].addEventListener("click", function(e){
    fermeMegamenu ()
  });

};



let liensMegamenu = document.querySelectorAll('.megamenu .columns .column a');
for (let i = 0; i < liensMegamenu.length; i++) {

  // Rollover
   liensMegamenu[i].addEventListener("mouseenter", function(e) {
      // menu

      let menu =  liensMegamenu[i].closest('.megamenu');
      let idMenu = menu.getAttribute('id');
     
      document.querySelector('#'+idMenu+' .megamenu-fond').className = 'megamenu-fond '+liensMegamenu[i].dataset.url
      document.querySelector('#'+idMenu+' .megamenu-fond-default').classList.add('masque')
      document.querySelector('#'+idMenu+' .megamenu-fond').classList.remove('masque')
    });

    liensMegamenu[i].addEventListener("mouseleave", function(e) {
         // menu

      let menu =  liensMegamenu[i].closest('.megamenu');
      let idMenu = menu.getAttribute('id');

      document.querySelector('#'+idMenu+' .megamenu-fond').className = "megamenu-fond"
      document.querySelector('#'+idMenu+' .megamenu-fond-default').classList.remove('masque')
      document.querySelector('#'+idMenu+' .megamenu-fond').classList.add('masque')
    });
}



export function ouvreMegamenu (id) {
  document.querySelector(id).classList.add('actif')
  document.querySelector('nav').classList.add('on-top')
  document.querySelector(id).style.top =  document.querySelector('nav').offsetHeight+'px'
  document.getElementById("overlay").classList.add("actif");
  document.getElementById("overlay").style.opacity = 1

}


export function fermeMegamenu () {
  let menus = document.querySelectorAll('.megamenu')
  for (let i = 0; i < menus.length; i++) {
    menus[i].classList.remove('actif')
    menus[i].classList.remove('actif')
    menus[i].style.top = '-500px'

    document.getElementById("overlay").style.opacity = 0

    setTimeout(function () {
      document.querySelector('nav').classList.remove('on-top')
    }, 300);

    setTimeout(function () {
      document.getElementById("overlay").classList.remove("actif")
    }, 500);

    

    }


}


function desactiveMegamenus() {
  let menus = document.querySelectorAll('.megamenu')

  for (let i = 0; i < menus.length; i++) {
    menus[i].classList.remove('actif')
  };

}
